import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../../action';
import * as c from '../../constant';

function MiscFeeSettingsFeesContent({
  handleRemove,
  handleEdit,
  miscFeesId,
  showMiscFeeSettingsFees,
  miscFeeSettingsFeesData,
}) {
  useEffect(() => {
    if (_.isEmpty(miscFeesId)) return;
    showMiscFeeSettingsFees(miscFeesId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(miscFeesId)) return;
    showMiscFeeSettingsFees(miscFeesId);
  }, [miscFeesId]);
  return (
    <div className="container-fluid card-section-content">
      {!_.isEmpty(miscFeeSettingsFeesData) ? (
        <React.Fragment>
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <h2 className="font-weight-bold text-uppercase">
                  {_.get(miscFeeSettingsFeesData, 'attributes.account_title') || '--'}
                </h2>
                <div className="col-4 d-flex px-0 mx-0">
                  <div className="ml-auto">
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleEdit(miscFeeSettingsFeesData)}
                    >
                      <i className="far fa-edit icon-edit" />
                    </button>
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleRemove(miscFeeSettingsFeesData)}
                    >
                      <i className="far fa-trash-alt icon-delete" />
                    </button>
                  </div>
                </div>
              </div>
              <hr />
              <div className="mt-1">
                <div className="row d-flex justify-content-center">
                  <div className="col-12">
                    <div className="form-wrapper mb-3">
                      <div className="full-group">
                        <div className="form-row">
                          <div className="form-input-group col-12">
                            <label className="full-label mb-0">
                              Fee Name:
                            </label>
                            <span className="full-input text-uppercase">
                              {_.get(
                                miscFeeSettingsFeesData,
                                'attributes.account_title'
                              ) || '--'}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12">
                            <label className="full-label mb-0">
                              Account Code:
                            </label>
                            <span className="full-input text-uppercase">
                              {_.get(
                                miscFeeSettingsFeesData,
                                'attributes.account_code'
                              ) || '--'}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12">
                            <label className="full-label mb-0">
                              PPSAS Code:
                            </label>
                            <span className="full-input text-uppercase">
                              {_.get(
                                miscFeeSettingsFeesData,
                                'attributes.ppsas_code'
                              ) || '--'}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-md-4 col-lg-2">
                            <label className="full-label mb-0">
                              GF:
                            </label>
                            <span className="full-input text-uppercase">
                              {_.get(
                                miscFeeSettingsFeesData,
                                'attributes.fund_types.gf'
                              ) === 1 ? 'Yes' : 'No' || '--'}
                            </span>
                          </div>
                          <div className="form-input-group col-md-4 col-lg-2">
                            <label className="full-label mb-0">
                              TF:
                            </label>
                            <span className="full-input text-uppercase">
                              {_.get(
                                miscFeeSettingsFeesData,
                                'attributes.fund_types.tf'
                              ) === 1 ? 'Yes' : 'No'  || '--'}
                            </span>
                          </div>
                          <div className="form-input-group col-md-4 col-lg-2">
                            <label className="full-label mb-0">
                              SEF:
                            </label>
                            <span className="full-input text-uppercase">
                              {_.get(
                                miscFeeSettingsFeesData,
                                'attributes.fund_types.sef'
                              ) === 1 ? 'Yes' : 'No' || '--'}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12">
                            <label className="full-label mb-0">
                              Office Involved:
                            </label>
                            <span className="full-input text-uppercase">
                              {_.get(
                                miscFeeSettingsFeesData,
                                'attributes.office_name'
                              ) || '--'}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12">
                            <label className="full-label mb-0">
                              Amount:
                            </label>
                            <span className="full-input">
                              ₱ {_.get(miscFeeSettingsFeesData,'attributes.amount_human') || '0.00'}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div className="d-flex align-items-center justitfy-content-center h-100">
          <div className="text-center mx-auto py-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
            />
            <p className="emp-title mb-0"> No Item Found </p>
          </div>
        </div>
      )}
    </div>
  );
}

MiscFeeSettingsFeesContent.propTypes = {
  handleRemove: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,

  showMiscFeeSettingsFees: PropTypes.instanceOf(Function).isRequired,
  miscFeeSettingsFeesData: PropTypes.instanceOf(Object).isRequired,
  miscFeesId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  miscFeeSettingsFeesData:
    _.get(api, `${c.SHOW_MISC_FEE_SETTINGS_FEES}.item`) || {},
  miscFeesId: _.get(match, 'params.userManagementId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(MiscFeeSettingsFeesContent);
